import { render, staticRenderFns } from "./DataProtectionFr.vue?vue&type=template&id=728905a3&scoped=true&"
import script from "./DataProtectionFr.vue?vue&type=script&lang=js&"
export * from "./DataProtectionFr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728905a3",
  null
  
)

export default component.exports